"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _intlI18n = require("@/i18n/intl-i18n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IntlBreadcrumb',
  mixins: [_intlI18n.intlMixin],
  props: {
    detailTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDetail: function isDetail() {
      return this.$route.path.includes('Detail') || this.$route.path.includes('courseLearn');
    },
    currentTitle: function currentTitle() {
      var map = {
        '/international/news': this.$t('nav.news'),
        '/international/courses': this.$t('nav.courses'),
        '/international/about': this.$t('nav.about')
      };
      return map[this.$route.path] || '';
    },
    parentPath: function parentPath() {
      if (this.$route.path.includes('newsDetail')) return '/international/news';
      if (this.$route.path.includes('courseDetail') || this.$route.path.includes('courseLearn')) return '/international/courses';
      return '/international/home';
    },
    parentTitle: function parentTitle() {
      if (this.$route.path.includes('newsDetail')) return this.$t('nav.news');
      if (this.$route.path.includes('courseDetail') || this.$route.path.includes('courseLearn')) return this.$t('nav.courses');
      return this.$t('nav.home');
    }
  }
};